<div *ngIf="message">
	<content-block class="container mt-4" *ngIf="displayOnPage" [showHeader]="false">
		<div class="row justify-content-center">
			<div class="card">
				<div class="card-body message-body">
					<h2 *ngIf="message?.category === 'Version'">{{ message?.version }}</h2>
					<div class="rendered-html" [innerHTML]="sanitizedMessage"></div>
				</div>
				<div class="card-footer d-flex justify-content-end" *ngIf="displayCloseBtn">
					<button class="btn btn-primary me-2" (click)="close(message)">
						{{ btnCloseLabel | translate }}
					</button>
				</div>
			</div>
		</div>
	</content-block>

	<div *ngIf="!displayOnPage">
		<div class="message-popup justify-content-center">
			<div class="modal-body message-body">
				<div class="rendered-html" [innerHTML]="sanitizedMessage"></div>
			</div>
			<div class="modal-footer d-flex justify-content-end" *ngIf="displayCloseBtn">
				<button class="btn btn-primary me-2" (click)="close(message)">
					{{ btnCloseLabel | translate }}
				</button>
			</div>
		</div>
	</div>
</div>
